function initRiderSlider(wrapper) {
  var track = wrapper.querySelector('.rider-slider-track');
  if (!track) return;

  var items = Array.from(track.children);
  if (items.length === 0) return;

  items.forEach(function (item) {
    track.appendChild(item.cloneNode(true));
  });

  var speed = parseInt(track.getAttribute('data-speed'), 10) || 40;
  track.style.animationDuration = speed + 's';
  track.classList.add('is-animated');

  var pauseOnHover = track.getAttribute('data-pause-hover') === 'true';
  if (pauseOnHover) {
    track.addEventListener('mouseenter', function () {
      track.classList.add('is-paused');
    });
    track.addEventListener('mouseleave', function () {
      track.classList.remove('is-paused');
    });
  }
}

function initAllRiderSliders() {
  document.querySelectorAll('.rider-slider-wrapper').forEach(initRiderSlider);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllRiderSliders);
} else {
  initAllRiderSliders();
}

document.addEventListener('shopify:section:load', function (event) {
  var section = event.target;
  if (section.classList.contains('rider-slider-section')) {
    initRiderSlider(section.querySelector('.rider-slider-wrapper'));
  }
});
